import React from "react";
import { Card, Collapse } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ReactComponent as CollapseSVG } from "go-core/images/svg/actions/collapse.svg";
import { VenueSettingsApi } from "../../../../../../../../../../../services/Api/Organization/types";
import { VenueSettingsItemApi } from "../../../../../../../../../../../services/Api/types";
import useCollapseCard from "../hooks/useCollapseCard";
import SettingsTable from "./SettingsTable";

interface Props {
	types: VenueSettingsItemApi[];
	form: UseFormReturn<VenueSettingsApi>;
	search: string;
}

const BackwardCompatibilitySettingsCard = ({ types, form, search }: Props) => {
	const { toggleCollapse, collapseIn, getCollapseIconStyles } = useCollapseCard(search, types);
	const { t } = useTranslation();

	return (
		<Card className={"venue-settings"}>
			<Card.Body>
				<div className={"title"} onClick={() => toggleCollapse()}>
					<h5>{t("modules.venue_settings.field.backward_compatibility.title")}</h5>
					<CollapseSVG style={getCollapseIconStyles()} className={"collapse-icon"} />
				</div>
				<Collapse in={collapseIn}>
					<div>
						<table className={"table table-preview"}>
							<SettingsTable types={types} form={form} />
						</table>
					</div>
				</Collapse>
			</Card.Body>
		</Card>
	);
};

export default BackwardCompatibilitySettingsCard;
